import React from 'react';
import { Wrap, Image, Text } from './Loader.styled';
import Label from '../Label';

const Loader = () => (
  <Wrap>
    <Image src="/images/configurator/loading.gif" alt="Loading" />
    <Text>
      <Label name="loadingLabel" fallback="Loading..." />
    </Text>
  </Wrap>
);

export default Loader;
